/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  mutation MyMutation($homePageAdsId: ID!) {
    HomePageAdsDelete(homePageAdsId: $homePageAdsId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
